class CartScripts {
  constructor() {
    (function ($) {
      "use strict";

      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
          );
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };

      $(document.body).on("wc_cart_emptied", function () {
        if ($(".woocommerce-cart-form").length === 0) {
          $(window.location).attr("href", "https://staging.gaiapoleeurope.com/");
          return;
        }
      });

      $("div.woocommerce").on("change", "input.qty", function () {
        $("[name='update_cart']")
          .removeAttr("disabled")
          .attr("aria-disabled", "false")
          .trigger("click");
      });

      window.loading_coupon = false;
      $(document).on("submit", ".gaia-cart-coupon", function (e) {
        e.preventDefault();
        var coupon_code = $("#gaia_coupon_code").val();
        if (!coupon_code) {
          alert(t('cart.enter_coupon'));
          return false;
        }
        var data = {
          action: "gaia_apply_coupon",
          coupon_code: coupon_code,
        };
        window.loading_coupon = true;
        $(this).addClass("loading");
        $.post(gaiaCustomData.ajax_url, data, function (response) {
          // console.log(response);
          $(".gaia-cart-coupon").removeClass("loading");

          if (response.success) {
            $("[name='update_cart']")
              .removeAttr("disabled")
              .attr("aria-disabled", "false")
              .trigger("click");
            setTimeout(() => {
              window.loading_coupon = false;
            }, 1500);
          } else {
            gaiaCartAlert(response.data, "error");
          }
        });
        return;
      });

      window.loading_garantia = false;
      $(".gaia_continue_checkout").on("click", function (e) {
        e.preventDefault();
        if (window.loading_garantia) return false;
        const btn = $(this);
        var garantia = $('[name="gaia_garantia"]:checked').val();
        if (!garantia) {
          alert(t('cart.select_warranty'));
          return false;
        }

        btn.addClass("loading");

        if (garantia !== "padrao") {
          var data = {
            action: "gaia_update_garantia",
            product_id: garantia,
          };
          window.loading_garantia = true;
          $.post(gaiaCustomData.ajax_url, data, function (response) {
            // console.log(response);

            if (
              response.result &&
              (response.result == "success" || response.result == "exists")
            ) {
              setTimeout(() => {
                window.location.href = t('checkout.url_checkout');
              }, 1000);
            } else if (response.result && response.result === "failure") {
              btn.removeClass("loading");
              alert("Ocorreu um erro, tente novamente.");
            }

            window.loading_garantia = false;
          });
        } else {
          // console.log('Garantia padrão');
          setTimeout(() => {
            window.location.href = t('checkout.url_checkout');
          }, 500);
        }

        return false;
      });

      $(document.body).on(
        "updated_cart_totals added_to_cart removed_from_cart",
        function (e) {
          var data = {
            action: "gaia_update_mini_cart",
          };
          $.post(gaiaCustomData.ajax_url, data, function (response) {
            // console.log(response);
            $(".gaia_cart_count").removeClass("hidden").html(response.count);
            if (!$(".woocommerce-cart").length)
              $(".gaia_mini_cart_content").html(response.html);
            // HSOverlay.open('#gaia-carrinho');

            if (e.type == "added_to_cart" && !$(".woocommerce-cart").length) {
              if (!$(".woocommerce-cart").length) {
                // $(".toast_added_cart").addClass("active");
                // setTimeout(() => {
                //   $(".toast_added_cart").removeClass("active");
                // }, 3500);

                // window.notify("Product added to cart", { 
                //   position: 'bottom-center',
                //   type: 'success',
                //   classes: '!min-w-80 md:!max-w-md !text-white',
                //   duration: 3500,
                //   closeOnClick: true,
                //   closeOnEsc: true,
                //   closeOnScroll: true,
                //   closeOnSwipe: true,
                // });

                const miniCart = HSOverlay.getInstance('#gaia-carrinho', true)?.element;
                miniCart.open();
              }
            }
          });
        }
      );

      // Configuração de Alertas
      $(".close_toast").on("click", function () {
        $(this).closest('[role="alert"]').removeClass("active");
      });
      function gaiaCartAlert(mensagem, tipo) {
        var $alertContainer = $('#gaia_cart_alert');
        // Adiciona classes de acordo com o tipo
        if (tipo === 'error') {
            $alertContainer.addClass('alert-error');
        } else if (tipo === 'info') {
            $alertContainer.addClass('alert-info');
        }

        $alertContainer.find('#gaia_cart_alert_content').html(mensagem);
        $alertContainer.addClass('active');
        
        setTimeout(() => {
            $alertContainer.removeClass('active');
            
            setTimeout(() => {
                $alertContainer.find('#gaia_cart_alert_content').html('');
                $alertContainer.removeClass('alert-error alert-info');
            }, 500)
        }, 3500);
      }

      $(document).on("click", ".gaia_proceed_checkout", function (e) {
        e.preventDefault();

        if (!window.gaia_updating_cart) {
          $(this).addClass("loading");
          window.location.href = t('checkout.url_warranty');
        }

        return;
      });

      window.gaia_updating_cart = false;
      $(document).ajaxStart(function () {
        if (isMobile.any()) {
          $(".gaia_load_totals_mobile").addClass("loading");
        }

        if (
          $(".woocommerce-cart").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          window.gaia_updating_cart = true;
          // console.log('O carrinho está sendo atualizado!');
          // $('.brindes-box').removeClass('hidden');
          $(".brindes-box").addClass("loading");
          $(".cross-sell-box").addClass("loading");
          $(".produtos-box").addClass("loading");
          $(".resumo-box").addClass("loading");
        }

        if (
          $(".gaia_mini_cart_content").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          $(".woocommerce-mini-cart-item").addClass("loading");
        }

        if (
          false &&
          $("#checkout-page").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          // console.log('O checkout está sendo atualizado!');
          $(".checkout-box-load").addClass("loading");
        }
      });

      $(document).ajaxStop(function () {
        if (
          $(".woocommerce-cart").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          window.gaia_updating_cart = false;
          // console.log('O carrinho foi atualizado!');
          $(".produtos-box").removeClass("loading");
          $(".slide-produtos-box").removeClass("loading");
          $(".resumo-box").removeClass("loading");
          $(".gaia_load_totals_mobile").removeClass("loading");
          window.HSStaticMethods.autoInit();
        }

        if (
          $(".gaia_mini_cart_content").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          $(".woocommerce-mini-cart-item").removeClass("loading");
        }

        if (
          false &&
          $("#checkout-page").length &&
          !window.loading_coupon &&
          !window.finding_cep
        ) {
          // console.log('O checkout foi atualizado!');
          setTimeout(() => {
            $(".checkout-box-load").removeClass("loading");
          }, 1500);
        }
      });

      $(document).ajaxComplete(function () {
        if (
          $("body").hasClass("woocommerce-checkout") ||
          $("body").hasClass("woocommerce-cart")
        ) {
          if (
            !$(".woocommerce-NoticeGroup-checkout .woocommerce-error").length
          ) {
            jQuery("html, body").stop();
          }

          $("#place_order").removeClass("loading");
        }
      });

      // Intercepta todas as respostas AJAX do WooCommerce
      // $(document).ajaxComplete(function(event, xhr, settings) {});

      $(document.body).on(
        "updated_cart_totals applied_coupon removed_coupon",
        function (e) {
          // Alertas WC
          var alertas_wc = $(".woocommerce-notices-wrapper").html();
          if (alertas_wc) {
            // console.log('Alertas encontrados');
            var tipo = "message";
            var message;
            if (
              $(".woocommerce-notices-wrapper .woocommerce-error").length > 0
            ) {
              var messages = $(
                ".woocommerce-notices-wrapper .woocommerce-error li"
              );
              tipo = "error";
              messages.each(function (i, msg) {
                message = msg.outerText;
                gaiaCartAlert(message, tipo);
              });
            } else if (
              $(".woocommerce-notices-wrapper .woocommerce-info").length > 0
            ) {
              message = $(
                ".woocommerce-notices-wrapper .woocommerce-info"
              ).html();
              tipo = "info";
              gaiaCartAlert(message, tipo);
            } else if (
              $(".woocommerce-notices-wrapper .woocommerce-message").length > 0
            ) {
              message = $(
                ".woocommerce-notices-wrapper .woocommerce-message"
              ).html();
              gaiaCartAlert(message, tipo);
            }
          }

          // Update Mobile Cart Totals
          if (isMobile.any()) {
            $(".gaia_load_totals_mobile").addClass("loading");
            var dataCartMobileTotals = {
              action: "gaia_cart_totals_mobile",
            };
            var requestCartMobileTotals = $.post(
              gaiaCustomData.ajax_url,
              dataCartMobileTotals
            );
            $.when(requestCartMobileTotals).done(
              function (responseCartMobileTotals) {
                var cartResponse = responseCartMobileTotals;
                // console.log(cartResponse);
                $("#gaia_cart_total").html(cartResponse.total);
                $("#gaia_cart_prices").html(cartResponse.precos);
                setTimeout(() => {
                  $(".gaia_load_totals_mobile").removeClass("loading");
                }, 1000);
              }
            );
          }

          // Brindes e Sugestões
          $(".brindes-box").addClass("loading");
          $(".cross-sell-box").addClass("loading");

          var dataBrindes = {
            action: "gaia_update_gifts",
          };

          var dataCrossSells = {
            action: "gaia_update_cross_sell",
          };

          var requestBrindes = $.post(gaiaCustomData.ajax_url, dataBrindes);
          var requestCrossSells = $.post(
            gaiaCustomData.ajax_url,
            dataCrossSells
          );

          $.when(requestBrindes, requestCrossSells).done(
            function (responseBrindes, responseCrossSells) {
              var brindesResponse = responseBrindes[0];
              var crossSellsResponse = responseCrossSells[0];

              // console.log(brindesResponse);
              if (brindesResponse.count > 0) {
                $(".brindes-box").removeClass("hidden");
                $("#refresh_gifts").html(brindesResponse.html);
              } else {
                $(".brindes-box").addClass("hidden");
              }

              setTimeout(() => {
                if (cartSlider[0]) {
                  cartSlider[0].destroy();
                  initSwiperProductsCart();
                }
                $(".brindes-box").removeClass("loading");
              }, 1000);

              // console.log(crossSellsResponse);
              if (crossSellsResponse.count > 0) {
                $(".cross-sell-box").removeClass("hidden");
                $("#refresh_cross_sell").html(crossSellsResponse.html);
              } else {
                $(".cross-sell-box").addClass("hidden");
              }

              setTimeout(() => {
                if (cartSlider[1]) {
                  cartSlider[1].destroy();
                  initSwiperProductsCart();
                }
                $(".cross-sell-box").removeClass("loading");
              }, 1000);

              window.gaia_updating_cart = false;
            }
          );
        }
      );

      // Slide Brindes
      var cartSlider;
      function initSwiperProductsCart() {
        cartSlider = new Swiper(".products-cart-slider", {
          slidesPerView: 2,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      }

      initSwiperProductsCart();

      // Checkout recarregado
      // $(document.body).on("updated_checkout", function (e) {
      //   $("#place_order").removeClass("loading");
      // });

      // setInterval(() => {
      //   if (
      //     window.wc_pagarme_checkout &&
      //     window.wc_pagarme_checkout.errorList
      //   ) {
      //     $("#place_order").removeClass("loading");
      //   }
      // }, 1000);

      // Mudança método de pagamento
      // $(document).on("change", '[name="payment_method"]', function () {
      //   $(document.body).trigger("update_checkout");
      // });

      // Preenchimento de endereço
      // function limpa_formulario_cep($e) {
      //     $e.closest('.gaia_checkout_form').find("#billing_address_1").val("");
      //     $e.closest('.gaia_checkout_form').find("#billing_neighborhood").val("");
      //     $e.closest('.gaia_checkout_form').find("#billing_city").val("");
      //     $e.closest('.gaia_checkout_form').find("#billing_state").val("");
      // }
      // window.finding_cep = false;
      // $("#billing_postcode").blur(function() {
      //     var $e = $(this);
      //     var cep = $(this).val().replace(/\D/g, '');
      //     if (cep != "") {
      //         var validacep = /^[0-9]{8}$/;
      //         if( validacep.test(cep) ) {
      //             window.finding_cep = true;
      //             $e.closest('.woocommerce-input-wrapper').addClass('loading');
      //             $.getJSON("//viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
      //                 if (!("erro" in dados)) {
      //                     $e.closest('.gaia_checkout_form').find("#billing_address_1").val(dados.logradouro);
      //                     $e.closest('.gaia_checkout_form').find("#billing_neighborhood").val(dados.bairro);
      //                     $e.closest('.gaia_checkout_form').find("#billing_city").val(dados.localidade);
      //                     $e.closest('.gaia_checkout_form').find("#billing_state").val(dados.uf);
      //                     $e.closest('.gaia_checkout_form').find("#billing_state").trigger("change");
      //                 }
      //                 else {
      //                     limpa_formulario_cep($e);
      //                     alert("CEP não encontrado.");
      //                 }
      //                 $e.closest('.woocommerce-input-wrapper').removeClass('loading');
      //                 window.finding_cep = false;
      //             });
      //         }
      //         else {
      //             limpa_formulario_cep();
      //             alert("Formato de CEP inválido.");
      //             $e.closest('.woocommerce-input-wrapper').removeClass('loading');
      //             window.finding_cep = false;
      //         }
      //     }
      //     else {
      //         limpa_formulario_cep();
      //         $e.closest('.woocommerce-input-wrapper').removeClass('loading');
      //         window.finding_cep = false;
      //     }
      // });

      // Botão finalizar compra
      // $(document).on("click", "#place_order", function (e) {
      //   if (!window.wc_pagarme_checkout.errorList) {
      //     $(this).addClass("loading");
      //   }
      // });
    })(jQuery);
  }
}

export default CartScripts;
